import React, { FunctionComponent, useState } from 'react';
import errorHandler from '../../../../common/service/errorHandler';
import usePlatformConfig from '../../../../common/react/usePlatformConfig';
import errorMessageHoc, {
  IErrorMessageHocProps,
} from '../../../../common/components/presentation/Error/errorMessageHoc';
import PAYMENT_TYPE from '../../../common/constants/paymentType';
import { GetDeal_deal } from '../../../common/graphql/queries/__generated__/GetDeal';
import MergedPaymentEwayContainer from './paymentProviders/eway/MergedPaymentEwayContainer';

export interface IPayment extends IErrorMessageHocProps {
  deal: GetDeal_deal;
  loading?: boolean;
  showCheckoutButton?: boolean;
}

const MergedPayment: FunctionComponent<IPayment> = ({ showCheckoutButton }) => {
  const [parentNodeId] = useState<string>('wrapper:checkout:paymentProvider');
  const {
    platformConfig: { paymentProvider },
  } = usePlatformConfig();

  const paymentProviderMap = {
    [PAYMENT_TYPE.EWAY]: <MergedPaymentEwayContainer showCheckoutButton={showCheckoutButton} />,
  };

  const selectedProvider = paymentProviderMap[paymentProvider];

  if (!selectedProvider) {
    errorHandler.handleError(`Merged payment step not supported by the payment provider. [${parentNodeId}]`);
    return (
      <div data-test="payment_page:no_payment_provider">Merged payment step not supported by the payment provider</div>
    );
  }

  return selectedProvider;
};

export default errorMessageHoc(MergedPayment);
